export const RENTSAL_CARS = "Rental Cars";
export const CHOOSE_DATES = "Choose Dates";
export const TIMES_AND_DRIVER_AGE = "Times and Driver Age";
